import { render, staticRenderFns } from "./mark-revision-completed.vue?vue&type=template&id=2de010f4&"
import script from "./mark-revision-completed.js?vue&type=script&lang=js&"
export * from "./mark-revision-completed.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports